module.exports = __webpack_public_path__ + "img/bg.dbc48871.png";